import React from 'react';
import { Box, Typography } from '@mui/material';
import { CompanyPromotionsList } from '../../components/CompanyPromotionsList';

export const CompanyPromotions = () => {
  return (
    <Box>
      <Typography mb="24px" variant="h1" sx={{ color: 'text.primary' }} component="h1">
        Акции компании
      </Typography>
      <Typography mb="24px" variant="h2" sx={{ color: 'text.secondary' }} component="h2">
        Список акций
      </Typography>
      <CompanyPromotionsList />
    </Box>
  );
};
